import { createFormikField } from '../../../../components/fields/utils/createFormikField';
import { TextField } from '../FieldText';
import { TextAreaField } from '../FieldTextArea';
import { FieldCurrency } from '../FieldCurrency';
import { FieldCombo } from '../FieldCombo';
import { FieldIncrement } from '../FieldIncrement';

export const FormikTextField = createFormikField(TextField);
export const FormikTextAreaField = createFormikField(TextAreaField);
export const FormikCurrencyField = createFormikField(FieldCurrency);
export const FormikComboField = createFormikField(FieldCombo);
export const FormikIncrementField = createFormikField(FieldIncrement);
